import Vue from 'vue'

import {
  getMatchedComponentsInstances,
  promisify,
  globalHandleError
} from './utils'

import '../assets/styles/main.scss'

import _77180f1e from '../layouts/blank.vue'
import _6f6c098b from '../layouts/default.vue'
import _103c6d61 from '../layouts/landing.vue'

const layouts = { "_blank": _77180f1e,"_default": _6f6c098b,"_landing": _103c6d61 }

export default {
  head: {"title":"New Seaton | Community Built From The Ground Up","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"keywords","content":"new seaton, new seaton pickering, new seatom community, new homes in durham, new homes durham, new seaton aspen ridge homes, aspen ridge homes, new seaton brookfield homes, brookfield homes, new seaton towerhill homes, towerhill homes, new townhomes pickering, new homes pickering"},{"hid":"description","name":"description","content":"At New Seaton, we have that new home feeling throughout our whole community. Every detail of this community has been planned to make your life easier."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Raleway:300,400,500,700,800,900"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.fontawesome.com\u002Freleases\u002Fv5.7.2\u002Fcss\u002Fall.css","integrity":"sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fgh\u002Ffancyapps\u002Ffancybox@3.5.6\u002Fdist\u002Fjquery.fancybox.min.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.typekit.net\u002Fimn2aal.css"}],"script":[{"src":"https:\u002F\u002Fcdn.tailwindcss.com"},{"src":"https:\u002F\u002Fcode.jquery.com\u002Fjquery-3.3.1.min.js","integrity":"sha256-FgpCb\u002FKJQlLNfOu91ta32o\u002FNMZxltwRo8QtmkMRdAu8=","crossorigin":"anonymous"},{"src":"https:\u002F\u002Fwww.google.com\u002Frecaptcha\u002Fapi.js?onload=vueRecaptchaApiLoaded&render=explicit","defer":true,"async":true},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fgh\u002Ffancyapps\u002Ffancybox@3.5.6\u002Fdist\u002Fjquery.fancybox.min.js"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=AW-711317830","async":true},{"src":"\u002F\u002Fjs.hs-scripts.com\u002F3390596.js","async":true,"id":"hs-script-loader","type":"text\u002Fjavascript"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-1DJZGMW520","async":true}],"style":[]},

  render (h, props) {
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: ''
  }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  computed: {
    isOffline () {
      return !this.isOnline
    }
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }

      const promises = pages.map((page) => {
        const p = []

        if (page.$options.fetch) {
          p.push(promisify(page.$options.fetch, this.context))
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        globalHandleError(error)
        this.error(error)
      }
    },

    setLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },
}
